import { LocationsFieldItem, UnresolvedLocationsFieldItem } from 'components/NewForm/LocationsFieldTypes';
import { CountryList } from 'lib/enum/country.enum';
import { FacebookCountryCode } from 'lib/enum/facebook-country-code-enum';
import { TargetingLocationType, UnresolvedTargetingLocationType } from 'lib/types/targeting-location';

export type JobVacancyTargetingLocation =
    | {
          country: FacebookCountryCode;
          name: string;
          radius: number;
          type: UnresolvedTargetingLocationType.UnresolvedCity;
      }
    | {
          country: FacebookCountryCode;
          metaKey: string;
          metaRegionKey: string | null;
          name: string;
          radius: number;
          regionName: string | null;
          type: TargetingLocationType.City;
      }
    | {
          country: FacebookCountryCode;
          type: TargetingLocationType.Country;
      };

export const JobVacancyTargetingLocationToLocationsFieldItem = (
    JobVacancyTargetingLocation: JobVacancyTargetingLocation,
): LocationsFieldItem | UnresolvedLocationsFieldItem => {
    switch (JobVacancyTargetingLocation.type) {
        case UnresolvedTargetingLocationType.UnresolvedCity:
            return {
                type: UnresolvedTargetingLocationType.UnresolvedCity,
                key: JobVacancyTargetingLocation.country,
                name: JobVacancyTargetingLocation.name,
                countryCode: JobVacancyTargetingLocation.country,
                countryName: CountryList[JobVacancyTargetingLocation.country],
                regionId: null,
                regionName: null,
                radius: JobVacancyTargetingLocation.radius,
            };
        case TargetingLocationType.City:
            return {
                type: TargetingLocationType.City,
                key: JobVacancyTargetingLocation.metaKey,
                name: JobVacancyTargetingLocation.name,
                countryCode: JobVacancyTargetingLocation.country,
                countryName: CountryList[JobVacancyTargetingLocation.country],
                regionId: JobVacancyTargetingLocation.metaRegionKey,
                regionName: JobVacancyTargetingLocation.regionName,
                radius: JobVacancyTargetingLocation.radius,
            };
        case TargetingLocationType.Country:
            return {
                type: TargetingLocationType.Country,
                key: JobVacancyTargetingLocation.country,
                name: CountryList[JobVacancyTargetingLocation.country],
                countryCode: JobVacancyTargetingLocation.country,
                countryName: CountryList[JobVacancyTargetingLocation.country],
                regionId: null,
                regionName: null,
                radius: null,
            };
    }
};
